import React, { Component, useState } from 'react';
import RegisterView from './RegisterView';
import RegisterVerificationView from './RegisterVerificationView'
import ReceiveMarketingView from './ReceiveMarketingView'
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import crmServices from '../../wsclient/crmservices'
import t from '../../utils/translateUtil';
import ModalAlert from '../../components/ModalAlert'
import Loading from '../../components/Loading'
import  { startCountDown}  from "../../utils/util"
import {getAppCfg, getBrowser, getSupportOrderLocation, getRejectTriggerContact, setSupportOrderContact, getCountries, getCountryDefault} from '../../utils/common'
import { connection, domainName } from '../../../portal.config';
import { CyprusFlagIcon } from '../../components/icons';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
const styles = theme => ({

});
function Register(props){
    const config = getAppCfg()
    let agreement_countries = config&&config.contact&&config.contact.agreement_countries?config.contact.agreement_countries:null
    let country_default = getCountryDefault(agreement_countries) ? getCountryDefault(agreement_countries) : null;

    const [active, setActive] = useState('main');
    const [error, setError] = useState({});
    const [showLoading, onShowLoading] = useState(false);
    const [register_info, setRegisterInfo] = useState({
                                                country_code: country_default.value,
                                                email_opt_out: false,
                                                sms_opt_out: false,
                                                country_agreement: country_default.value
                                            });
    const [auth_otp, setAuthOtp] = useState(null);
    const [obfuscated_value, setObfuscatedValue] = useState(null);
    const [validation, setValiadation] = useState({});
    const [countDown, setCountDown] = useState('');
    const [timer_otp, setTimeOTP] = useState({});
    const [country_select, setSelectCountry] = useState(country_default)
    const [accept_policy, setAcceptPolicy] = useState(false);

    const auth_support = config && config.auth_support ? config.auth_support: {facebook:false, google:false};
    const requestTimer = 30;      
    
    
    const onRequestOTP = async(values) => {
        onShowLoading(true);
        let temp_register_info = {...register_info}
        setRegisterInfo(prevState => ({
            ...prevState,
            first_name: values.first_name,
            last_name: values.last_name,
            phone: values.phone,
            referral_code: values.referral_code,
        }));

        temp_register_info.first_name = values.first_name;
        temp_register_info.last_name = values.last_name;
        temp_register_info.phone = values.phone;
        temp_register_info.referral_code = values.referral_code;

        try {
            let result = await crmServices.contacts.registerByPhone({ ...temp_register_info, password: '123456' });
            if (result.code == 'OK') {
                onShowLoading(false);
                beginCountDown()
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp);
                    setObfuscatedValue(result.data.obfuscated_value);
                }
                setActive('verify');
            } else {
                console.log("register by phone exception:", result.code );
                showAlert('ERROR', t(result.code))
            }
        } catch (error) {
            console.log("register by phone exception:", error);
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);    
    }
    const onVerifyOTP = async(code) => {
        onShowLoading(true)
        try {
            let result = await crmServices.contacts.validateOTP({ phone: register_info['phone'], auth_otp: auth_otp, otp: code.verification_code });
            if (result.code === 'OK') {
                //crmServices.contacts.addApplicationUsage(config.id,getBrowser().toUpperCase());
                onShowLoading(false);
                setActive('receive_marketing');
                if(!getSupportOrderLocation()&&!getRejectTriggerContact()){
                    
                    let ordering_countries = []
                    if(config.features && config.features.ordering&&config.features.ordering_details&&config.features.ordering_details.ordering_countries){
                        ordering_countries = config.features.ordering_details.ordering_countries
                    }
                    let isAllowOrder = await dataUtil.checkAllowOrderByContact(ordering_countries);
                    if(isAllowOrder){
                        setSupportOrderContact(true)
                    }
                }

                props.history.push('/home');
            } else {
                showAlert('ERROR', t('INVALID_OTP'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }
    const onResendCode = async() => {
        onShowLoading(true);
        try {
            let result = await crmServices.contacts.sendSMSOTP(register_info['phone']);
            if (result.code === 'OK') {
                if (result.data && result.data.auth_otp) {
                    setAuthOtp(result.data.auth_otp)
                }
                showAlert('SUCCESS', t('OTP_RESEND_SUCCESS'))
                beginCountDown();
            } else if(result.code=='TOO_MANY_REQUESTS'){
                showAlert(t('ERROR'), t('TOO_MANY_REQUESTS'));
            } else if(result.code=='TOO_MANY_RECIPIENTS_EXCEPTION'){
                showAlert(t('ERROR'), t('TOO_MANY_RECIPIENTS_EXCEPTION'));
            } else {
                showAlert('ERROR', t('EXCEPTION_PROCESS'))
            }
        } catch (error) {
            showAlert('ERROR', t('EXCEPTION_PROCESS'))
        }
        onShowLoading(false);
    }

    const onReceiveMarketing = async (target, value) => {
        setRegisterInfo(prevState => ({
            ...prevState,
            [target]: value,
        }));
    }
    const onCancelReceiveMarketing = () =>{
        setActive('home')
        props.history.push('/home');
    }
    const showAlert = (status, message, title) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            title: title,
            message: message,
            status: status})
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            title: '',
            message: '',
            status: ''
        })
    }
    const beginCountDown = () => {

        let timerOTP = {
            interval: 1000, //in millisecond - 1 second 
            decreaseVal: 1,
            intervalInstance: undefined
        };
        console.log('Count down timer ', requestTimer);
        timerOTP.fromVal = Number(requestTimer);

        startCountDown(timerOTP, setCountDown,timer_otp);
        setCountDown(timerOTP.fromVal);
        setTimeOTP(timerOTP);
    }
    const onSelectCountry = (key, value) => {
        if(key==='country_code'){
            setRegisterInfo(prevState => ({
                ...prevState,
                [key]: value.value,
            }));
            setSelectCountry(value)
        }
        else{
            setRegisterInfo(prevState => ({
                ...prevState,
                [key]: value.target.value,
            }));
        }
    }
    const onChangeCheckboxPolicy = () => {
        setAcceptPolicy(!accept_policy);
    }
    const renderPage = (active) => {
        if(active==='main')
            return(
                <RegisterView
                onSubmit={onRequestOTP}
                showAlert={showAlert}
                onShowLoading={onShowLoading}
                onReceiveMarketing={onReceiveMarketing}
                register_info= {register_info}
                onSelectCountry={onSelectCountry}
                country_select={country_select}
                auth_support={auth_support}
                agreement_countries={getCountries()}
                country_default={country_default}
                onChangeCheckboxPolicy={onChangeCheckboxPolicy}
                accept_policy={accept_policy}/>)         
        else if(active==='verify'){
            return(
                <RegisterVerificationView
                onSubmit={onVerifyOTP}
                onResend={onResendCode}
                obfuscated_value={obfuscated_value}
                countDown={countDown}/>
            )
        }     

    }

        let page = renderPage(active);
        return (
            <div>
            {page}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />
            {showLoading && <Loading showLoading={showLoading} />}
            </div>

        );
}


export default withStyles(styles)(withTranslation()(Register));